export const ABOUT_2_CONSTANTS = {
  // Metadata titles for better identification in admin panel
  METADATA_TITLES: {
    metadata: "Key Highlights",
    metadata_2: "Alumni Avatars",
    metadata_3: "Carousel Images",
  },

  // Alumni avatars for the rating strip — media option only, desktop only.
  // `metadata` holds Key Highlights and `metadata_1` belongs to About 1 / 3,
  // hence slot 2.
  // Carousel slides for the media slot. Leave empty to show the single
  // "Media — Desktop Image" instead.
  DEFAULT_ROW_3: {
    id: "1",
    image: "",
    alt_image: "",
    enable_video: false,
    video_link: "",
    priority: 1,
    status: true,
  },

  DEFAULT_ROW_2: {
    id: "1",
    image: "",
    priority: 1,
    status: true,
  },

  // Default row for metadata (key highlights)
  DEFAULT_ROW: {
    id: "1",
    title: "",
    title_color: "#00D4EB",
    subtitle: "",
    subtitle_color: "rgba(255, 255, 255, 0.8)",
    priority: 1,
    status: true,
  },

  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "title_1",
      label: "Title 1",
      value: "Program",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
      required: false,
      defaultValue: "Program",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title 1 Color (e.g., #FFFFFF)",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "Overview",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      defaultValue: "Overview",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_2_gradient_angle",
      label: "Title 2 Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "Description",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Description Text Color",
      value: "rgba(255, 255, 255, 0.9)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "rgba(255, 255, 255, 0.9)",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Background Color",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "enable_lead_form",
      label: "Enable Lead Form",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Lead Form",
      required: false,
      defaultValue: false,
    },

    // ── Right-hand slot ──────────────────────────────────────────────────
    // The single-image fields below (desktop_image / mobile_image / alt_image)
    // are commented out rather than deleted: About 2's media slot is
    // driven entirely by the "Carousel Images" repeater, which carries its
    // own image, alt text and per-slide video. Leaving them editable would let an
    // editor fill in settings that never render. The columns still exist and are
    // untouched — About 1 and About 3 read them from the same shared table.
    // Desktop (≥1080) shows EITHER the lead form OR media — never both. Below
    // 1080 the lead form always wins and this toggle has no effect, so mobile
    // is unchanged. Turning it on also reveals the rating / alumni strip
    // below, which belongs to the media option and never renders on mobile.
    {
      fieldName: "show_image",
      label: "Show carousel instead of lead form (desktop only)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the carousel instead of the lead form",
      required: false,
      defaultValue: false,
    },
//  {
//    fieldName: "desktop_image",
//    label: "Media — Desktop Image",
//    value: "",
//    valueType: "string",
//    filedType: "FILE",
//    placeholder: "Upload desktop image",
//    required: false,
//    defaultValue: "",
//  },
//  {
//    fieldName: "mobile_image",
//    label: "Media — Mobile Image (unused on About 2, mobile shows the form)",
//    value: "",
//    valueType: "string",
//    filedType: "FILE",
//    placeholder: "Upload mobile image",
//    required: false,
//    defaultValue: "",
//  },
//  {
//    fieldName: "alt_image",
//    label: "Media — Image Alt Text",
//    value: "",
//    valueType: "string",
//    filedType: "INPUT",
//    placeholder: "Describe the image",
//    required: false,
//    defaultValue: "",
//  },
    {
      // Named "Background Video" on Banner 2, which is doubly misleading: it is
      // not a background, and it replaces the whole carousel rather than one
      // image. Labelled for what it does.
      fieldName: "video_link",
      label: "Video (replaces the entire carousel)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder:
        "Optional. When uploaded, this video autoplays (muted, looping, no controls) instead of the carousel",
      required: false,
      defaultValue: "",
    },

    // ── Rating / alumni strip (carousel option only) ─────────────────────
    {
      fieldName: "show_learners",
      label: "Show Alumni Count (carousel only)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide the alumni strip",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "learners_description",
      label: "Alumni Text",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Join 10k+ alumni",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "learners_description_color",
      label: "Alumni Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "show_rating",
      label: "Show Rating (carousel only)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show/Hide the rating",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "rating_number",
      label: "Rating Number",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "4/5",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "rating_number_color",
      label: "Rating Number Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "rating_text",
      label: "Rating Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "(7812 ratings)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "rating_color",
      label: "Rating Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "About Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable About Section",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS_3: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Carousel Image",
      defaultValue: "",
    },
    {
      header: "Alt Text",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      defaultValue: "",
    },
    {
      // The slide keeps showing its image; this adds a play button that opens
      // the video in an overlay. It does NOT replace the image.
      header: "Show Play Button",
      fieldName: "enable_video",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Overlay a play button on this slide",
      defaultValue: false,
    },
    {
      header: "Video Link (opens in overlay)",
      fieldName: "video_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "YouTube URL",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_2: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Alumni Avatar",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],

  // Metadata: Key Highlights (pairs of title/subtitle with colors)
  METADATA_FIELDS: [
    {
      header: "Title",
      fieldName: "title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (e.g., 2 Years)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Title Color",
      fieldName: "title_color",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #00D4EB)",
      defaultValue: "#00D4EB",
    },
    {
      header: "Subtitle",
      fieldName: "subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Subtitle (e.g., Online Program)",
      required: false,
      defaultValue: "",
    },
    {
      header: "Subtitle Color",
      fieldName: "subtitle_color",
      value: "rgba(255, 255, 255, 0.8)",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subtitle color (e.g., #FFFFFF)",
      defaultValue: "rgba(255, 255, 255, 0.8)",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],
};
